import { ContextFormByIdProvider, IContextFormByIdBeforeMount } from "@ngt/forms";
import { FC, PropsWithChildren } from "react";
import { useParams } from "react-router-dom";
import { FormDefinitions } from "../../api/dtos";

export interface IAgentFormByIdRouteProps extends PropsWithChildren {
    agentId?: number | undefined;

    loadBeforeMount?: boolean | IContextFormByIdBeforeMount;
    validateBeforeMount?: boolean | IContextFormByIdBeforeMount;
}

const AgentFormByIdRoute: FC<IAgentFormByIdRouteProps> = ({
    agentId,
    loadBeforeMount,
    validateBeforeMount,
    children
}) => {
    const params = useParams();

    const agentIdToUse = (params.agentId ? +params.agentId : undefined) ?? agentId ?? undefined;

    return (
        <ContextFormByIdProvider
            formId={agentIdToUse}
            formDefinitionIdentifier={FormDefinitions.Agent}

            loadBeforeMount={loadBeforeMount}
            //LoadingComponent={RouteLoading}

            validateBeforeMount={validateBeforeMount}
            //ValidatingComponent={RouteLoading}
        >
            {children}
        </ContextFormByIdProvider>
    );
}

export default AgentFormByIdRoute;
